import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ChartDataSets, ChartType, RadialChartOptions } from 'chart.js';
import { BaseChartDirective, Label } from 'ng2-charts';

@Component({
  selector: 'app-job-status-totals-donut',
  templateUrl: './job-status-totals.component.html',
  styleUrls: ['./job-status-totals.component.scss'],
})
export class JobStatusTotalsComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  @Input() jobs: any[] = [];

  sold: number = 0;
  lost: number = 0;
  pending: number = 0;
  total: number = 0;

  radarChartOptions: RadialChartOptions = {
    responsive: true,
    legend: {
      display: false
      // position: 'left',
      // align: 'center'
    }
  };
  radarChartLabels: Label[] = ['Sold', `Pending`, 'Lost'];
  radarChartData: ChartDataSets[] = [
    { data: [0, 0, 0,], label: 'Job Totals' },
  ];
  colorScheme = [
    { 
      backgroundColor:["#6abb42", "#edd1ce", "#c70d0d"] 
    }
  ];
  radarChartType: ChartType = 'doughnut';

  constructor() { }

  ngOnInit(): void {
    this.calculateTotals();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['jobs']) {
      this.calculateTotals();
    }
  }
  
  get percentage(): number {
    return this.total ? (this.sold / this.total) * 100 : 0;
  }

  private calculateTotals(): void {
    this.sold = this.jobs.filter(job => job.status === 'sold').length;
    this.lost = this.jobs.filter(job => job.status === 'lost').length;
    this.pending = this.jobs.filter(job => job.status === 'pending').length;
    this.total = this.sold + this.lost + this.pending;
    this.setChartData();
  }

  setChartData() {
    this.radarChartData = [{
      data: [
        this.sold,
        this.pending,
        this.lost
      ], label: 'Job Totals'
    }]
  }
}
